export default __webpack_public_path__ + "static/media/tableqr.95045210.svg";